import React, { useEffect, useMemo, useState } from 'react';
import { Button, Image, Modal } from 'react-bootstrap';
import { connect, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';

import i18n from 'I18n';

import { ACTION_BUTTON_STATUS } from 'component/campaign/CheckInSection';
import Scanner from 'component/campaign/Scanner';
import StampCampaignActionButton from 'component/campaign/StampCampaignActionButton';
import StampCampaignCouponAlert from 'component/campaign/StampCampaignCouponAlert';
import CommonAnimatedIcon from 'component/common/CommonAnimatedIcon';
import {
  DownloadSectionMobile,
  DownloadSectionWeb,
} from 'component/common/NoWebappDownloadSection';
import {
  EARNING_RULE_GPS,
  EARNING_RULE_PURCHASE,
  EARNING_RULE_QR_CODE,
  EARNING_RULE_REFER,
} from 'services/CampaignAPIHelper';

import { createAction, detectIsMobile, getTranslationData } from 'utils';
import { checkIfExpired } from 'utils/CampaignUtil';
import { DOWNLOAD_APP_DOMAIN } from 'utils/Config';
import { isPadOrMobile } from 'utils/ScreenUtils';
import { hideDownloadAppSection } from 'utils/UIConfigUtils';

import './StampSection.scss';

import giftAcquireDefault from 'assets/images/Badge_gift.png';
import badgeAcquiredDefault from 'assets/images/Badge_star.png'
import iconTask from 'assets/images/TaskIcon.png';
import giftSlotImage from 'assets/images/badgeGift.png';
import badgeSlotImage from 'assets/images/badgeIcon.png';
import { openLoginPage } from "utils/SSOUtil"
import { requestLocation } from "utils/LocationUtil";
import { requestMiniProgramScan, inMiniProgram } from 'utils/WeChatUtil'

const mapStateToProps = (state, ownProps) => {
  const { campaignID } = ownProps;
  const currentCampaign = state.campaignDetail[campaignID];
  const { actionBar, data } = currentCampaign || {};
  const { stampCampaigns } = data || {};

  return {
    tasks: stampCampaigns?.tasks,
    badges: stampCampaigns?.badges || [],
    campaignEndDate: actionBar?.endDate,
    earnedStamps: actionBar?.earnedStamps,
    redeemedRewardCoupons: actionBar?.redeemedRewardCoupons,
    stampBadge: actionBar?.stampBadge,
    membershipID: state.users.userInfo.memberShipID,
    isLogin: state.users.isLogin,
  };
};

const TaskCard = (props) => {
  const {
    title,
    cardType,
    rewardString,
    rewardStringSecond,
    rewardOfEachString,
    badgeAcquired,
  } = props;
  const isButton = cardType === 'button';

  const animationSource = badgeAcquired || badgeAcquiredDefault;

  return (
    <div className="task-card-container">
      <div className="task-card-top-section">
        <Image className="task-card-icon task-icon-filter" src={iconTask} />
        <label className="task-card-name subheading">{title}</label>
      </div>
      <div className="task-card-bottom-section">
        <div className="task-card-reward-container">
          <span className="task-card-reward-number headline">
            {rewardString}
          </span>
          <CommonAnimatedIcon
            source={animationSource}
            className="task-card-reward-icon"
            useLottie={!badgeAcquired || badgeAcquired?.endsWith('.json')}
          />
          {rewardStringSecond ? (
            <span className="task-card-reward-number-extra headline">
              {i18n.t(rewardStringSecond, { value: rewardOfEachString })}
            </span>
          ) : null}
        </div>
        {isButton && <StampCampaignActionButton {...props} />}
      </div>
    </div>
  );
};

const MyTask = ({
  data,
  onGetBadgeEventStart,
  campaignID,
  onTickFinished,
  badgeAcquired,
}) => {
  const hideDownloadSection = hideDownloadAppSection();
  return (
    <div className="task-wrap">
      {data?.map((props, index) => {
        const key = `taskcard_${index}`;
        return (
          <TaskCard
            key={key}
            {...props}
            earningRuleType={props.earningRuleType}
            onGetBadgeEventStart={onGetBadgeEventStart}
            onTickFinished={onTickFinished}
            badgeAcquired={badgeAcquired}
            campaignID={campaignID}
            cardType={hideDownloadSection ? props?.cardType : null}
          />
        );
      })}
    </div>
  );
};

const BadgeCardStatus = {
  NORMAL: 'NORMAL',
  DISABLE: 'DISABLE',
  ACQUIRED: 'ACQUIRED',
};

const BadgeCard = ({
  text,
  style,
  icon,
  onPress,
  active,
  rowNumber,
  isGift,
  isCouponSoldOut,
  playAnimation,
  useLottie,
  useIconFilter,
}) => {
  const status = useMemo(() => {
    if (!isGift) {
      return BadgeCardStatus.NORMAL;
    }
    if (!active) {
      return BadgeCardStatus.NORMAL;
    }
    if (isCouponSoldOut) {
      return BadgeCardStatus.DISABLE;
    }
    return BadgeCardStatus.ACQUIRED;
  }, [active, isGift, isCouponSoldOut]);

  return (
    <div className={`badge-card-container badge-card-container-${style}`}>
      <button
        className="badge-card-button"
        onClick={onPress}
        disabled={status !== BadgeCardStatus.ACQUIRED}
      >
        <div className={`badge-card-icon-container`}>
          <CommonAnimatedIcon
            className={`badge-card-icon ${useIconFilter ? "badge-card-icon-filter": ""}`}
            source={icon}
            useLottie={useLottie}
            playAnimation={playAnimation}
          />
          {status === BadgeCardStatus.ACQUIRED ? (
            <div className="badge-card-tick">
              <img
                src="/campaignDetail/badgeTick.png"
                srcSet="/campaignDetail/badgeTick@2x.png 2x, /campaignDetail/badgeTick@3x.png 3x"
              />
            </div>
          ) : null}
          {status === BadgeCardStatus.ACQUIRED ? (
            <div className="badge-card-acquire-container">
              <span className="badge-card-acquire-text tag-menu-2">
                {i18n.t('campaignDetail:view')}
              </span>
            </div>
          ) : null}
          {status === BadgeCardStatus.DISABLE ? (
            <div className="badge-card-acquire-container acquired">
              <span className="badge-card-acquire-text tag-menu-2">
                {i18n.t("campaignDetail:sold_out")}
              </span>
            </div>
          ) : null}
        </div>
        <span className="badge-card-index body-2">{text}</span>
      </button>
      <div className={`badge-card-line badge-card-line-${style}`} />
    </div>
  );
};

const MyStamp = ({
  stampInOneLine,
  badges,
  earnedStamps,
  redeemedRewardCoupons,
  stampBadge,
}) => {
  const history = useHistory();
  const dispatch = useDispatch();

  const gifts = badges.map(
    ({ required_stamps: requiredBadges }) => requiredBadges,
  );
  const total = gifts[gifts.length - 1];
  const badgeGet = earnedStamps;

  const { badgeSlot, badgeAcquired, giftSlot, giftAcquire } = stampBadge;

  const data = [];
  let subList = [];
  for (let i = 0; i < total; i += 1) {
    if (i >= stampInOneLine && i % stampInOneLine === 0) {
      data.push(subList);
      subList = [];
    }
    subList.push(i + 1);
  }
  data.push(subList);
  return (
    <>
      <div className="badge-container">
        {data.map((aList, index1) => {
          let lineStyle = index1 % 2 === 0 ? 'left' : 'right';
          return (
            <div
              key={`badge-row-${index1}`}
              className={`badge-row-container ${
                index1 % 2 === 0 ? '' : 'badge-row-reverse'
              }`}
            >
              {aList.map((textNumber, index2) => {
                if (textNumber % stampInOneLine === 0) {
                  lineStyle = 'bottom';
                }
                const dataPropsFilter = badges.filter(
                  (aData) => aData.required_stamps === textNumber,
                );
                const dataProps = dataPropsFilter ? dataPropsFilter[0] : null;
                const active = textNumber <= badgeGet;
                const isGift = gifts.includes(textNumber);
                const rewardID = dataProps?.id;
                const rewardType = dataProps?.reward_type;
                const rewardCouponIDs =
                  redeemedRewardCoupons?.find(
                    (item) => item?.stamp_reward === rewardID,
                  )?.coupon_ids ?? [];

                const mBadgeSlot = badgeSlot || badgeSlotImage;
                const mBadgeAcquired = badgeAcquired || badgeAcquiredDefault;
                const mGiftSlot = giftSlot || giftSlotImage;
                const mGiftAcquire = giftAcquire || giftAcquireDefault;

                let badgeIcon = mBadgeSlot;
                let useLottie = false;
                let useIconFilter = false
                if (isGift) {
                  badgeIcon = active ? mGiftAcquire : mGiftSlot;
                  useLottie =
                    active && (!giftAcquire || giftAcquire?.endsWith('.json'));
                  useIconFilter = !active && !giftSlot;
                } else {
                  badgeIcon = active ? mBadgeAcquired : mBadgeSlot;
                  useLottie =
                    active &&
                    (!badgeAcquired || badgeAcquired?.endsWith('.json'));
                  useIconFilter = !active && !badgeSlot;
                }

                if (textNumber === total) {
                  lineStyle = null;
                }

                return (
                  <BadgeCard
                    key={`badge-card-${index1}-${index2}`}
                    useIconFilter={useIconFilter}
                    text={textNumber}
                    rowNumber={index1}
                    style={lineStyle}
                    icon={badgeIcon}
                    active={active}
                    isGift={isGift}
                    isCouponSoldOut={
                      rewardType === 'COUPON' && !(rewardCouponIDs?.length > 0)
                    }
                    useLottie={useLottie}
                    playAnimation={textNumber === badgeGet}
                    onPress={() => {
                      if (!active || !isGift) {
                        return;
                      }
                      if (rewardType === 'POINTS') {
                        const isMobile = isPadOrMobile();
                        if (isMobile) {
                          history.push('/activity_log');
                        } else {
                          history.push('/user/myProfile');
                        }
                      } else if (rewardType === 'COUPON') {
                        console.log('@@253', dataProps);
                        // const { quantity } = dataProps;
                        if (rewardCouponIDs?.length > 1) {
                          // multiple open my wallet
                          dispatch(createAction('myCoupon/changeTab')({ index: 0 }));
                          history.push('/user/myCoupon');      
                          return;
                        }
                        if (rewardCouponIDs?.length === 1) {
                          // single open coupon Detail
                          const couponID = rewardCouponIDs[0];
                          history.push(`/coupon/${couponID}`);
                        }
                      }
                    }}
                  />
                );
              })}
            </div>
          );
        })}
      </div>
    </>
  );
};

function StampSection({
  campaignID,
  inBlackoutPeriod,
  tasks,
  badges,
  campaignEndDate,
  earnedStamps,
  redeemedRewardCoupons,
  stampBadge,
  membershipID,
  isLogin,
}) {
  const history = useHistory();
  const dispatch = useDispatch();
  const isPadOrMobileView = isPadOrMobile();
  const [stampInOneLine, setStampInOneLine] = useState(
    isPadOrMobileView ? 4 : 3,
  );
  const [showScanQRCode, setShowScanQRCode] = useState(false);
  const [showActionModal, setShowActionModal] = useState(false);
  const [modalDescription, setModalDescription] = useState('');
  const [modalButtonIsRefer, setModalButtonIsRefer] = useState(false);
  const [buttonEarningRuleId, setButtonEarningRuleId] = useState(null);
  const [buttonRewardStampCount, setButtonRewardStampCount] = useState(null);
  const [qrCodeString, setQrCodeString] = useState(null);
  const isMobile = detectIsMobile();
  const hideDownloadSection = hideDownloadAppSection();
  const isInMiniProgram = inMiniProgram()
  useEffect(() => {
    const windowResizeFunction = () => {
      setStampInOneLine(isPadOrMobileView ? 4 : 3);
    };
    window.addEventListener('resize', windowResizeFunction);
    return () => {
      window.removeEventListener('resize', windowResizeFunction);
    };
  }, []);

  useEffect(() => {
    if (qrCodeString) {
      dispatch(
        createAction('campaignDetail/verifyQrCode')({
          qrCodeString: qrCodeString,
          campaignID,
          earningRuleID: buttonEarningRuleId,
          inStampCampaign: true,
          rewardStampCount: buttonRewardStampCount,
        }),
      );
      setQrCodeString(null);
    }
  }, [dispatch, qrCodeString]);

  const onGetBadgeEventStart = (
    earningRuleID,
    earningRuleType,
    rewardStampCount,
  ) => {
    if (inBlackoutPeriod) {
      dispatch(
        createAction('navBars/updateState')({
          toastShowing: {
            value: true,
            content: i18n.t('campaignDetail:blackoutLimit'),
          },
        }),
      );
      return;
    }
    if (checkIfExpired(campaignEndDate)) {
      dispatch({
        type: 'navBars/updateState',
        payload: {
          toastShowing: {
            value: true,
            content: i18n.t('campaignDetail:expireToast'),
          },
        },
      });
    } else if (!isLogin) {
      openLoginPage({locale: i18n?.language || 'en' })
    } else if (earningRuleType === EARNING_RULE_PURCHASE) {
      history.push('/transaction');
    } else if (earningRuleType === EARNING_RULE_QR_CODE && isMobile) {
      setButtonEarningRuleId(earningRuleID);
      setButtonRewardStampCount(rewardStampCount);
      if (!isInMiniProgram) {
        setShowScanQRCode(true);
      } else {
        requestMiniProgramScan({
          onSuccess: (result) => setQrCodeString(result),
          onFail: (errorMessage) => dispatch({
            type: 'navBars/updateState',
            payload: {
              toastShowing: {
                value: true,
                content: errorMessage,
              },
            },
          })
        })
      }
    } else if (earningRuleType === EARNING_RULE_GPS && isMobile) {
      requestLocation({
        dispatch: dispatch,
        data: {
          earningRuleID,
          campaignID,
          inStampCampaign: true,
          rewardStampCount
        },
        geoTimeout: {
          enableHighAccuracy: false,
          timeout: 5000,
          maximumAge: 0,
        }
      })
    } else if (
      earningRuleType === EARNING_RULE_REFER &&
      isMobile &&
      navigator.share
    ) {
      navigator.share({
        title: '',
        text: i18n.t('referMessage', {
          link: `${DOWNLOAD_APP_DOMAIN}/?referCode=${membershipID}`,
          code: membershipID,
        }),
      });
    } else {
      let modalDescriptionTemp = '';
      if (earningRuleType === EARNING_RULE_QR_CODE) {
        modalDescriptionTemp = i18n.t('campaignDetail:noCamera');
      } else if (earningRuleType === EARNING_RULE_GPS) {
        modalDescriptionTemp = i18n.t('campaignDetail:useMobileDevice');
      } else if (earningRuleType === EARNING_RULE_REFER) {
        modalDescriptionTemp = i18n.t('referMessage', {
          link: `${DOWNLOAD_APP_DOMAIN}/?referCode=${membershipID}`,
          code: membershipID,
        });
      }
      setModalDescription(modalDescriptionTemp);
      setModalButtonIsRefer(earningRuleType === EARNING_RULE_REFER);
      setButtonEarningRuleId(earningRuleID);
      setButtonRewardStampCount(rewardStampCount);
      setShowActionModal(true);
    }
  };

  const onTickFinished = (earningRuleID, campaignID) => {
    setTimeout(() => {
      dispatch({
        type: 'campaignDetail/updateActionButtonStatus',
        payload: {
          earningRuleID,
          campaignID,
          inStampCampaign: true,
          status: ACTION_BUTTON_STATUS.DISABLE,
        },
      });
    }, 1000);
  };

  const actionModalButton = () => {
    if (modalButtonIsRefer) {
      return (
        <>
          <button
            className="left_btn button-large"
            onClick={() => {
              setShowActionModal(false);
            }}
          >
            {i18n.t('close')}
          </button>
          <button
            className="right_btn button-large"
            onClick={() => {
              navigator.clipboard.writeText(
                i18n.t('referMessage', {
                  link: `${DOWNLOAD_APP_DOMAIN}/?referCode=${membershipID}`,
                  code: membershipID,
                }) || '',
              );
              setShowActionModal(false);
              dispatch({
                type: 'navBars/updateState',
                payload: {
                  toastShowing: {
                    value: true,
                    content: i18n.t('copySuccessfully'),
                    showTickIcon: true,
                  },
                },
              });
            }}
          >
            {i18n.t('copy')}
          </button>
        </>
      );
    }
    return (
      <>
        <button
          className="right_btn button-large"
          onClick={() => {
            dispatch({
              type: 'campaignDetail/updateActionButtonStatus',
              payload: {
                earningRuleID: buttonEarningRuleId,
                campaignID,
                inStampCampaign: true,
                status: ACTION_BUTTON_STATUS.DISABLE,
              },
            });
            setShowActionModal(false);
          }}
        >
          {i18n.t('campaign_ok')}
        </button>
      </>
    );
  };

  return (
    <>
      <div className="stamp-wrap">
        <div className="stamp-card-container">
          <label className="stamp-card-title headline">
            {i18n.t('campaignDetail:stampCard')}
          </label>
          <MyStamp
            stampInOneLine={stampInOneLine}
            badges={badges}
            earnedStamps={earnedStamps}
            redeemedRewardCoupons={redeemedRewardCoupons}
            stampBadge={stampBadge}
          />
        </div>
        <label className="task-card-title headline">
          {i18n.t('campaignDetail:tasks')}
        </label>
        <MyTask
          campaignID={campaignID}
          data={tasks?.parseList}
          badgeAcquired={stampBadge?.badgeAcquired}
          onGetBadgeEventStart={onGetBadgeEventStart}
          onTickFinished={onTickFinished}
        />
        {!hideDownloadSection ? <DownloadSectionWeb /> : null}
      </div>
      {isMobile && showScanQRCode ? (
        <Scanner
          show={showScanQRCode}
          handleClose={() => {
            setShowScanQRCode(false);
          }}
          setQRCodeString={(code) => setQrCodeString(code)}
          onError={(errorMessage) => {
            dispatch({
              type: 'navBars/updateState',
              payload: {
                toastShowing: {
                  value: true,
                  content: errorMessage,
                },
              },
            });
          }}
        />
      ) : (
        <Modal
          show={showActionModal}
          onHide={() => {
            setShowActionModal(false);
          }}
          className="use_coupon_modal"
          centered
        >
          <Modal.Body className="use_coupon_modal_content d-flex-column">
            <div>
              <p className="use_coupon_title title-medium-1">
                {modalDescription}
              </p>
            </div>
            <div className="button_group">{actionModalButton()}</div>
          </Modal.Body>
        </Modal>
      )}
    </>
  );
}

export default connect(mapStateToProps)(StampSection);
